module.exports = __webpack_public_path__ + "static/media/SalaryPaid.44d11850.svg";